import { PermissionName } from '@/business-logic/profile'
import { Permissions, PermissionLevels } from '@/shared/Permissions'

export const getLevelPermissions = (
  permissions: Permissions,
  forDisplay = false
) => {
  const level0PermissionActions: PermissionLevels[] = [
    {
      permissionName: 'SETDATA',
      type: 'app.controller_permissions.permissions_block.profile_data.profile_data',
      info: 'app.controller_permissions.permissions_block.profile_data.can_upload',
      isActive: !!permissions.SETDATA,
    },
    {
      permissionName: 'SIGN',
      type: 'activity.event.sign',
      info: 'app.controller_permissions.permissions_level.profile_data.sign.description',
      isActive: !!permissions.SIGN,
    },
    {
      permissionName: 'ENCRYPT',
      type: 'app.controller_permissions.permissions_level.profile_data.encrypt.title',
      info: 'app.controller_permissions.permissions_level.profile_data.encrypt.description',
      isActive: !!permissions.ENCRYPT,
    },
    {
      permissionName: 'DECRYPT' as PermissionName,
      type: 'app.controller_permissions.permissions_level.profile_data.decrypt.title',
      info: 'app.controller_permissions.permissions_level.profile_data.decrypt.description',
      isActive: !!permissions.DECRYPT,
    },
  ]

  const level3PermissionActions: PermissionLevels[] = [
    {
      permissionName: 'CALL',
      type: 'app.controller_permissions.permissions_block.account.call',
      info: 'app.controller_permissions.permissions_block.account.call_info',
      isActive: !!permissions.CALL,
    },
    {
      permissionName: 'STATICCALL',
      icon: 'call',
      type: 'app.controller_permissions.permissions_block.account.staticcall',
      info: 'app.controller_permissions.permissions_block.account.staticcall_info',
      isActive: !!permissions.STATICCALL,
    },
    {
      permissionName: 'DELEGATECALL',
      icon: 'call',
      type: 'app.controller_permissions.permissions_block.account.delegatecall',
      info: 'app.controller_permissions.permissions_block.account.delegatecall_info',
      isActive: !!permissions.DELEGATECALL,
    },
    {
      permissionName: 'TRANSFERVALUE',
      icon: 'call',
      type: 'app.controller_permissions.permissions_block.account.transfervalue',
      info: 'app.controller_permissions.permissions_block.account.transfervalue_info',
      isActive: !!permissions.TRANSFERVALUE,
    },
  ]

  const level1PermissionActions: PermissionLevels[] = [
    {
      permissionName: 'CALL',
      type: 'app.controller_permissions.permissions_block.account.interactions',
      info: 'app.controller_permissions.permissions_block.account.can_read',
      isActive: !!permissions.CALL,
      isForward: true,
    },
    {
      permissionName: 'DEPLOY',
      type: 'app.controller_permissions.permissions_level.account.deploy.title',
      info: 'app.controller_permissions.permissions_level.account.deploy.description',
      isActive: !!permissions.DEPLOY,
    },
    {
      permissionName: 'REENTRANCY',
      type: 'app.controller_permissions.permissions_level.account.reentrancy.title',
      info: 'app.controller_permissions.permissions_level.account.reentrancy.description',
      isActive: !!permissions.REENTRANCY,
    },
    {
      permissionName: 'ADDEXTENSIONS',
      type: 'app.controller_permissions.permissions_level.admin.addextensions.title',
      info: 'app.controller_permissions.permissions_level.admin.addextensions.description',
      isActive: !!permissions.ADDEXTENSIONS,
    },
    {
      permissionName: 'CHANGEEXTENSIONS',
      type: 'app.controller_permissions.permissions_level.admin.changeextensions.title',
      info: 'app.controller_permissions.permissions_level.admin.changeextensions.description',
      isActive: !!permissions.CHANGEEXTENSIONS,
    },
    {
      permissionName: 'ADDUNIVERSALRECEIVERDELEGATE',
      type: 'app.controller_permissions.permissions_level.admin.adduniversalreceiverdelegate.title',
      info: 'app.controller_permissions.permissions_level.admin.adduniversalreceiverdelegate.description',
      isActive: !!permissions.ADDUNIVERSALRECEIVERDELEGATE,
    },
    {
      permissionName: 'CHANGEUNIVERSALRECEIVERDELEGATE',
      type: 'app.controller_permissions.permissions_level.admin.changeuniversalreceiverdelegate.title',
      info: 'app.controller_permissions.permissions_level.admin.changeuniversalreceiverdelegate.description',
      isActive: !!permissions.CHANGEUNIVERSALRECEIVERDELEGATE,
    },
    {
      permissionName: 'EXECUTE_RELAY_CALL',
      type: 'app.controller_permissions.permissions_level.admin.execute_relay_call.title',
      info: 'app.controller_permissions.permissions_level.admin.execute_relay_call.description',
      isActive: !!permissions.EXECUTE_RELAY_CALL,
    },
  ]

  if (forDisplay) {
    level1PermissionActions.splice(0, 1, ...level3PermissionActions)
  }

  const level2PermissionActions: PermissionLevels[] = [
    {
      permissionName: 'CHANGEOWNER',
      type: 'app.controller_permissions.permissions_level.admin.changeownership.title',
      info: 'app.controller_permissions.permissions_level.admin.changeownership.description',
      isActive: !!permissions['CHANGEOWNER'],
    },
    {
      permissionName: 'EDITPERMISSIONS',
      type: 'app.controller_permissions.permissions_level.admin.editpermissions.title',
      info: 'app.controller_permissions.permissions_level.admin.editpermissions.description',
      isActive: !!permissions['EDITPERMISSIONS'],
    },
    {
      permissionName: 'ADDCONTROLLER',
      type: 'app.controller_permissions.permissions_level.admin.addcontrollers.title',
      info: 'app.controller_permissions.permissions_level.admin.addcontrollers.description',
      isActive: !!permissions['ADDCONTROLLER'],
    },
  ]

  return {
    level0PermissionActions,
    level1PermissionActions,
    level2PermissionActions,
    level3PermissionActions,
  }
}
